const TextInput = ({ value, setValue }: { value: any; setValue: Function }) => {
  return <input value={value.display_value} />
}

export default TextInput
